import fr from "./fr";

const frBE = {
  ...fr,
  footer: {
    ...fr.footer,
    copyright: "© {{year}} CRAFTFINDUS. Pour les entreprises artisanales en Belgique.",
  },
  home: {
    ...fr.home,
    seoTitle: "Trouver un artisan en Belgique | Liège, Namur, Charleroi",
    seoDesc: "CRAFTFINDUS Belgique : Trouvez gratuitement le bon artisan. Électricien, plombier, couvreur à Liège, Namur, Charleroi et dans toute la Wallonie.",
    heroDesc: "Décrivez votre projet. Nous trouvons 3 à 5 entreprises artisanales en Belgique pour vous. Gratuit, en moins de 24 heures.",
    electricianDesc: "Installation électrique, éclairage, tableau électrique – trouvez un électricien à Liège, Namur ou Charleroi.",
    plumbingDesc: "Rénovation de salle de bain, remplacement de chauffage – des installateurs professionnels en Wallonie.",
    roofingDesc: "Rénovation de toiture, lucarnes, charpente – des couvreurs expérimentés en Belgique.",
    constructionDesc: "Placo, carrelage, rénovation complète – entreprises de construction à Liège, Namur et Mons.",
    faqC1A: "Oui, absolument ! CRAFTFINDUS est conçu pour la Belgique. Décrivez votre projet – nous trouvons le bon métier et les meilleures entreprises en Wallonie pour vous.",
    faqC3A: "En général, des entreprises qualifiées de votre région en Belgique vous contactent dans les 24 heures.",
    faqP1A: "Vous recevez des demandes de projets pré-qualifiées de Belgique, correspondant à votre métier et votre région en Wallonie.",
  },
  auth: {
    ...fr.auth,
    emailPlaceholder: "votre@email.be",
  },
  inquiry: {
    ...fr.inquiry,
    seoTitle: "Soumettre une demande – Artisans qualifiés en Belgique",
    seoDesc: "Soumettez une demande chez CRAFTFINDUS Belgique : trouvez jusqu'à 5 entreprises artisanales qualifiées en Wallonie.",
    regionPlaceholder: "p.ex. Liège, 4000",
    contactPhonePlaceholder: "+32 ...",
  },
  onboarding: {
    ...fr.onboarding,
    regionPlaceholder: "p.ex. Liège, 4000",
  },
};

export default frBE;
